import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { variant } from 'styled-system';
import { UI_LAYERS } from '@keen.io/ui-core';
var containerVariants = {
    prop: 'placement',
    variants: {
        'top-center': {
            alignItems: 'center',
            top: '100px',
            left: '50%',
            transform: 'translateX(-50%)',
        },
        'bottom-center': {
            alignItems: 'center',
            bottom: '100px',
            left: '50%',
            transform: 'translateX(-50%)',
        },
    },
};
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  max-height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  z-index: ", ";\n\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  max-height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  z-index: ", ";\n\n  ", ";\n"])), UI_LAYERS.notification, variant(containerVariants));
var templateObject_1;
